import {useEffect, useState} from "react";

export function useDebouncedValue<T>(value: T, delayMs: number = 300): T {

    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const timeoutId = setTimeout(() => setDebouncedValue(value), delayMs);
        return () => clearTimeout(timeoutId);
    }, [value, delayMs]);

    return debouncedValue;
}

export default useDebouncedValue;
